import styled from 'styled-components';

import { ChatConversation } from 'services/api/chat';
import { colors } from 'styles/theme/colors';
import { FONT_WEIGHT_MEDIUM } from 'styles/theme/textStyles';
import { BodySmall } from 'styles/typography';

import UnreadBadge from './UnreadBadge';

type Props = {
  conversation: ChatConversation;
  selected: boolean;
  onSelect: (conversationId: string) => void;
};

// A single facility row in the channel rail: the facility name with an unread badge inline after
// it (Figma "Multi Facility Access" — the badge follows the name, it is not right-justified).
export default function ChannelListItem({ conversation, selected, onSelect }: Props) {
  return (
    <Row
      type='button'
      $selected={selected}
      aria-current={selected}
      data-testid='chat-channel-item'
      onClick={() => onSelect(conversation.id)}>
      <Name $selected={selected}>{conversation.audience.name}</Name>
      {/* The channel being viewed never DISPLAYS a badge: it is read-up-to-rendered by
          definition, and suppressing here (not in the cache) makes the tick-refetch vs
          mark-read race unable to flash a badge for a message the viewer is watching. */}
      {!selected && <UnreadBadge count={conversation.unreadCount} mentioned={conversation.unreadMentioned} />}
    </Row>
  );
}

const Row = styled.button<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border: none;
  cursor: pointer;
  text-align: left;
  padding: 9px 12px;
  border-radius: 6px;
  background: ${({ $selected }) => ($selected ? colors.blue10 : 'transparent')};

  &:hover {
    background: ${({ $selected }) => ($selected ? colors.blue10 : colors.black3)};
  }
`;

const Name = styled(BodySmall)<{ $selected: boolean }>`
  color: ${({ $selected }) => ($selected ? colors.blue100 : colors.black100)};
  font-weight: ${({ $selected }) => ($selected ? FONT_WEIGHT_MEDIUM : 'inherit')};
`;
